import TagManager from 'react-gtm-module';

/**
 * `type` identifies the hero variant, not the page template — MainHero is
 * rendered on both category info pages and landing pages, so the two must
 * not be conflated in reporting.
 */
export const CIP_HERO_TYPE = 'CIP hero';

export interface TrackMainHeroCtaClickProps {
  data: {
    /** Path the click happened on, e.g. `/en/products/camping-and-hiking` */
    interactionLocation: string;
    /** Href the CTA navigates to */
    linkUrl: string;
    linkText: string;
    /** 0-based position of the CTA within the hero (up to 3) */
    index: number;
  };
}

export const trackMainHeroCtaClick = ({ data }: TrackMainHeroCtaClickProps) => {
  const { interactionLocation, linkUrl, linkText, index } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_hero_cta',
      interaction: {
        interaction_location: interactionLocation,
        link_url: linkUrl,
        link_text: linkText,
        // Sent as a string to match the other interaction trackers (see
        // trackPlpHeroEvents) — GA4 reads it as a dimension, not a metric.
        index: index.toString(),
        type: CIP_HERO_TYPE,
      },
    },
  });
};
